<template>
  <div>
    <el-form
      ref="searchForm"
      :inline="true"
      class="searchBoxLine"
      :model="searchForm"
    >
      <el-form-item label="项目名称:" prop="projectName">
        <el-input
          v-model.trim="searchForm.projectName"
          placeholder="请输入项目名称"
        />
      </el-form-item>

      <el-form-item label="合同编号:" prop="contractNum">
        <el-input
          v-model.trim="searchForm.contractNum"
          placeholder="请输入合同编号"
        />
      </el-form-item>

      <el-form-item label="销售人员:" prop="createByName">
        <el-input
          v-model.trim="searchForm.createByName"
          placeholder="请输入销售人员姓名"
        />
      </el-form-item>

      <el-form-item label="供货单位:" prop="supplyUnit">
        <el-select
          v-model="searchForm.supplyUnit"
          placeholder="请选择供货单位"
          clearable
        >
          <el-option
            v-for="option in supplyUnit"
            :key="option.code"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="订单分类:" prop="contractType">
        <el-select
          v-model="searchForm.contractType"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in orderType"
            :key="option.code"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block; width: 10px; text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>

      <el-form-item label="最终客户名称:" prop="clientName">
        <el-input
          v-model.trim="searchForm.clientName"
          placeholder="请输入最终客户名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="tableLoading" class="tableBody">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        tooltip-effect="light"
      >
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="left show-overflow-tooltip"
          min-width="170"
          fixed="left"
        >
          <template v-slot="{ row }">
            <el-button
              type="text"
              class="el-btn-text-left"
              @click="jumpContractDetail(row)"
            >
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="contractNum"
          label="合同编号"
          align="left"
          min-width="140"
        />

        <el-table-column
          prop="contractType"
          label="订单分类"
          align="left"
          min-width="140"
        >
          <template v-slot="{ row }">
            <span v-if="row.freightContract">
              {{ row.contractType + "(价外费用)" }}
            </span>
            <span v-else>{{ row.contractType }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="contractSum"
          label="订单金额"
          align="right"
          header-align="left"
          min-width="120"
        >
          <template v-slot="{ row }">
            {{ Number(row.contractSum).toFixed(2) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="salesManName"
          label="销售人员"
          align="left"
          min-width="90"
        />
        <el-table-column
          prop="createTime"
          label="合同时间"
          align="left"
          width="140"
        />

        <el-table-column prop="date" label="操作" width="120" align="left" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="applyShipment(row)">
              申请发货
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper, sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import { selectSpecialContractInfoList } from '@/API';

export default {
  data () {
    return {
      tableLoading: false,
      searchForm: {
        projectName: '',
        contractNum: '',
        createByName: '',
        contractType: '',
        clientName: '',
        supplyUnit: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      }
    };
  },

  computed: {
    ...mapState({
      // 订单分类
      orderType: state => state.enumeration.orderType,
      // contracStatus: state => state.enumeration.contracStatus,
      // 供货单位
      supplyUnit: state => state.enumeration.supplyUnit
    })
  },

  mounted () {
    this.doSearch();
  },

  methods: {
    doSearch () {
      this.tableLoading = true;
      let params = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      selectSpecialContractInfoList(params).then((res) => {
        this.tableLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.list;
          this.$set(this.tableData, 'removeVisible', false);
          this.page.currentPage = data.pageNum;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChange (val) {
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 改变当前页
    handerCurrentChange (val) {
      this.doSearch();
    },

    // 合同详情插线
    jumpContractDetail (row) {
      this.$router.push({
        name: 'ContractInfo',
        params: { contractNum: row.contractNum },
        query: {
          id: row.contractId,
          masterProjectName: row.projectName,
          isSon: true,
          distributeFlag: true
        }
      });
    },

    // 申请发货
    applyShipment (row) {
      this.$router.push({
        name: 'sendGoodsStrategy',
        query: {
          contractNum: row.contractNum,
          contractId: row.contractId
        }
      });
    }

  }

};
</script>
